import { CacheKeys } from 'cache-keys-enum';
import { ApiRoute, SortOrder } from 'enums';

import { createContext } from 'react';
import { useQuery } from 'react-query';
import { ArchivalAidMetadata, ArchivalCollection, Result } from 'types';
import fetch from 'utils/fetch';

export const ArchivalCollectionsListContext = createContext<
  Result<ArchivalCollection>
>({});

export const useArchivalCollectionList = () => {
  const response = useQuery([CacheKeys.COLLECTION_LIST], () =>
    fetch('/api/' + ApiRoute.ARCHIVAL_COLLECTION + '/list', {
      method: 'POST',
      body: JSON.stringify({
        sort: [{ field: 'name', order: 'ASC' as SortOrder }],
        size: -1,
      }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    }).then(async (r) => (await r.json()) as Result<ArchivalAidMetadata>)
  );
  return response;
};
